import { render, staticRenderFns } from "./BuyerAccountBudget.vue?vue&type=template&id=5d18666a&scoped=true"
import script from "./BuyerAccountBudget.vue?vue&type=script&lang=js"
export * from "./BuyerAccountBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d18666a",
  null
  
)

export default component.exports